import React from 'react'
import Progress from './Progress'
import { Box, Typography } from '@mui/material'

function StatBox({ title, subtitle, icon, progress, increase }) {
  return (
    <Box width="100%" m="0 30px">
      {/* <Box justifyContent={'center'} alignSelf={'center'} ></Box> */}
      <Box display="flex" justifyContent="space-between">
      <Typography variant="h6" sx={{ color: "black"}}>
          {subtitle}{icon}
        </Typography>
        <Typography
          variant="h7"
          fontStyle="italic"
          sx={{ color: "green" }}
        >
          {increase}
        </Typography>
      </Box>
      <Box display="flex" justifyContent="space-between" mt="2px">
      <Box>
        <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ color: "gray" }}
          >
            {title}
          </Typography>
        </Box>
        <Box>
          <Progress progress={progress} />
        </Box>
        
      </Box>
    </Box>
  )
}

export default StatBox